import * as React from "react";
import { makeTranslator } from "../../utils/translations";
import { ResourceItem } from "../../commonTypes/resourceItem";

export interface IWizardStepperStaticProps {
  steps: StaticStepState[];
  translations: ResourceItem[];
}

export interface StaticStepState {
  stepLabel?: string;
  isActive?: boolean;
  done?: boolean;
}
let Translations: (key: string, defaultValue?: string) => string;

export class WizardStepperStatic extends React.Component<IWizardStepperStaticProps> {
  constructor(props: IWizardStepperStaticProps) {
    super(props);
    Translations = makeTranslator(this.props.translations);
  }

  renderSteps = (stepState: StaticStepState, index: number) => {
    let activeClass = stepState.isActive
      ? "wizardstepperstatic__step--active"
      : "";
    activeClass += stepState.done ? " wizardstepperstatic__step--done" : "";
    let ariaLabelItem = stepState.isActive
      ? Translations("ariaLabelCurrentStep", "Nuvarande steg ")
      : Translations("ariaLabelStep", "steg ");
    const steg = index + 1;
    ariaLabelItem += steg + ": " + stepState.stepLabel;

    return (
      <li key={`staticstep_${index}`} className="wizardstepperstatic__li">
        <div className={`wizardstepperstatic__step ${activeClass}`}></div>
        <div className="sr-only">{ariaLabelItem}</div>
        <div className="wizardstepperstatic__label" aria-hidden="true">
          {stepState.stepLabel}
        </div>
      </li>
    );
  };

  render() {
    const { steps } = this.props;
    return (
      <div className="wizardstepperstaticwrapper">
        <ol
          className="wizardstepperstatic"
          aria-label={Translations(
            "ariaLabelWhereInProcess",
            "Var är jag i processen?"
          )}
        >
          {steps.map(this.renderSteps)}
        </ol>
        <div className="wizardstepperstatic__line"></div>
      </div>
    );
  }
}
